module.exports = __webpack_public_path__ + "static/media/mobilesteps.f562f71b.png";